export const ACTIONS = {
	SHOW_IMAGE_EDITOR: 'SHOW_IMAGE_EDITOR',
	HIDE_IMAGE_EDITOR: 'HIDE_IMAGE_EDITOR',
};
